import $api from "../http";
import { AxiosResponse } from "axios";

export default class UserService {

    static getUsers(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/users/')
    };

    static getUsersFull(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/users/full/')
    };

    static updateUsersFull(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/users/full/${id}`, data)
    };

    static getUser(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/user/')
    };

    static delUser(id: any): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/del/user/${id}`)
    };

    static getSpecializations(data: any): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/specialization/?query=${data}`)
    };

    static createSpecialization(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/specialization/', data)
    };

    static deleteSpecialization(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/specialization/${id}`)
    };

    static getOrganizations(data: any): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/organization/?query=${data}`)
    };

    static createOrganization(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/organization/', data)
    };

    static deleteOrganization(id: number): Promise<AxiosResponse<any>> {
        return $api.delete<any>(`api/organization/${id}`)
    };

    static getDiseases(data: any): Promise<AxiosResponse<any>> {
        return $api.get<any>(`api/disease/?query=${data}`)
    };

    static createDisease(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/disease/', data)
    };

    static getUserInfo(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/user_info/')
    };

    static createUserInfo(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/user_info/', data)
    };

    static updateUserInfo(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/user_info/${id}`, data)
    };

    static getSpecInfoFull(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/spec_info/full/')
    };

    static getSpecInfo(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/spec_info/')
    };

    static createSpecInfo(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/spec_info/', data)
    };

    static updateSpecInfo(id: number, data: any): Promise<AxiosResponse<any>> {
        return $api.patch<any>(`api/spec_info/${id}`, data)
    };

    static createSpecActive(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/spec_active/', data)
    };

    static getSpecActive(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/spec_active/')
    };

    static createFeedback(data: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/feedback/', data)
    };

    static getFeedback(): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/feedback/')
    };

    static goToMoodle(fio: any): Promise<AxiosResponse<any>> {
        return $api.post<any>('api/go_to_moodle/', fio)
    };

    static getSearchedInfo(params: any): Promise<AxiosResponse<any>> {
        return $api.get<any>('api/search/', {params})
    };

};